import React from "react";
import { Form } from "@redriver/cinnamon";
import { Grid } from "semantic-ui-react";
import { TitlesDropdown } from "components/forms";
import { CustomerTypes } from "constants/enums";

const CustomerContactForm = ({ customerType, titleText, lockPrimary }) => {
  const jobTitleRequired = customerType != CustomerTypes.Residential;

  return (
    <Grid>
      <Grid.Row>
        <Grid.Column width={4}>
          <TitlesDropdown
            unknownValueText={titleText}
            field="titleId"
            label="Title"
            placeholder=""
            clearable
            fluid
          />
        </Grid.Column>
        <Grid.Column width={6}>
          <Form.Input field="firstName" label="First Name" required fluid />
        </Grid.Column>
        <Grid.Column width={6}>
          <Form.Input field="lastName" label="Last Name" required fluid />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Form.Input field="phoneNumber" label="Phone" required fluid />
        </Grid.Column>
        <Grid.Column>
          <Form.Input field="mobileNumber" label="Mobile" required fluid />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2}>
        <Grid.Column>
          <Form.Input
            field="jobTitle"
            label="Job Title"
            required={jobTitleRequired}
            fluid
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Email
            field="email"
            label="Email"
            required
            emailValidation
            fluid
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row>
        <Grid.Column>
          <Form.Checkbox
            field="isMain"
            label="Primary contact"
            disabled={lockPrimary}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default CustomerContactForm;
